module.exports = __webpack_public_path__ + "static/media/time.982e702c.svg";